import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  CompanyInfo,
  EditCampaign,
  EmailCampaign,
  EmailTemplates,
  EmailTemplatesCreation,
  Fields,
  Layouts,
  NewCampaign,
  OrganisationChart,
  PermissionProfile,
  UIDemo,
  Users,
  IpWhiteLists,
  SearchLayout,
  GeneralSettings,
  ObjectImport,
  ObjectExport,
  SetUpWelPage,
  WorkFlow,
  ApiToken
} from 'views/index';
import { Permission } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';

const prefix = 'setup';

const SetupRoutes = () => (
  <Switch>
    <Route path={`/${prefix}/company-info/ui-demo`} component={UIDemo} />
    <Route
      path={`/${prefix}/company-info/company-info`}
      component={CompanyInfo}
    />
    <Route path={`/${prefix}/company-info/users`} component={Users} />
    <Route
      path={`/${prefix}/company-info/chart`}
      component={OrganisationChart}
    />
    <Route
      path={`/${prefix}/company-info/permissions`}
      component={PermissionProfile}
    />
    <Route path={`/${prefix}/:objectType/fields`} component={Fields} />
    <Route path={`/${prefix}/:objectType/pageLayout`} component={Layouts} />
    <Route path={`/${prefix}/email/templates`} component={EmailTemplates} />
    <Route
      path={`/${prefix}/email/template-edit/:templateId`}
      component={EmailTemplatesCreation}
    />
    <Route
      path={`/${prefix}/email/templates-creation`}
      component={EmailTemplatesCreation}
    />
    <Route path={`/${prefix}/email/campaign`} component={EmailCampaign} exact />
    <Route
      path={`/${prefix}/email/campaign/edit/:campaignId`}
      component={EditCampaign}
    />
    <Route path={`/${prefix}/email/campaign/new`} component={NewCampaign} />
    <Route
      path="/setup/systems/ip-setting"
      render={() => (
        <Permission permission={PERMISSIONS.SETUP_SYSTEMS_IPWHITELIST}>
          <IpWhiteLists />
        </Permission>
        )
      }
    />
    <Route
      path="/setup/settings/search-layout"
      render={() => (
        <Permission permission={PERMISSIONS.SETUP_GENERALSETTINGS_SEARCHLAYOUT_VIEW}>
          <SearchLayout />
        </Permission>
      )}
    />
    <Route
      path={`/${prefix}/settings/general-setting`}
      render={() => (
        <Permission permission={PERMISSIONS.SETUP_GENERALSETTINGS_OTHERSETTINGS_VIEW}>
          <GeneralSettings />
        </Permission>
      )}
    />
    <Route
      path={`/${prefix}/settings/object-import`}
      render={() => (
        <Permission permission={PERMISSIONS.SETUP_OBJECTSIMPORT}>
          <ObjectImport />
        </Permission>
      )}
    />
    <Route path={`/${prefix}/indexPage`} component={SetUpWelPage} />
    <Route
      path={`/${prefix}/settings/object-export`}
      render={() => (
        <Permission permission={PERMISSIONS.SETUP_OBJECTSEXPORT}>
          <ObjectExport />
        </Permission>
      )}
    />
    <Route
      path={`/${prefix}/settings/workflow`}
      render={() => (
        <Permission permission={PERMISSIONS.SETUP_WORKFLOW}>
          <WorkFlow />
        </Permission>
      )}
    />
    <Route 
      path={`/${prefix}/settings/api-token`}
      render={() => (
        <Permission permission={PERMISSIONS.SETUP_APITOKEN}>
          <ApiToken />
        </Permission>
      )}
    />
  </Switch>
);

export default SetupRoutes;



// WEBPACK FOOTER //
// ./src/components/page/MainContent/components/SetupRoutes.jsx